/* Packages */
import React from 'react';
import { render } from 'react-dom';

const ProductIntroNodes = Array.from(document.querySelectorAll('[data-product-variants]'));
if (ProductIntroNodes.length) {
    import(/* webpackChunkName: "ProductIntro" */ './components/ProductIntro').then(({ default: ProductIntro }) => {
        ProductIntroNodes.forEach((node) => render(<ProductIntro {...(JSON.parse(node.dataset.productVariants || '{}'))} />, node));
    });
}